import PropTypes from 'prop-types';
import config from 'config';

const getTenant = (tenant) => {
  const { environment, environmentList, defaultTenant } = config;

  // When running on localhost, use configured default tenant (e.g., core.local)
  if (!tenant || tenant === 'localhost') {
    return defaultTenant;
  }

  // If the subdomain equals an environment label, default to core for that env
  if (environmentList.includes(tenant)) {
    return `core.${environment}`;
  }

  return `${tenant}.${environment}`;
};

getTenant.propTypes = {
  tenant: PropTypes.string,
};

export default getTenant;
